import { BehaviorSubject, type Observable } from 'rxjs';

/**
 * Where the AI island rests in a view: its centre in the window's coordinates. The island owns its
 * place and never moves for a surface that docks to it; such a surface (the copilot's panel) lays
 * itself around this point.
 */
export interface AIIslandAnchor {
  readonly x: number;
  readonly y: number;
}

export interface AIIslandAnchorScope {
  readonly workspaceId: string;
  readonly viewId: string;
}

const anchors = new Map<string, BehaviorSubject<AIIslandAnchor | null>>();

function anchorOf({ workspaceId, viewId }: AIIslandAnchorScope) {
  const key = `${workspaceId}:${viewId}`;
  let anchor$ = anchors.get(key);
  if (!anchor$) {
    anchor$ = new BehaviorSubject<AIIslandAnchor | null>(null);
    anchors.set(key, anchor$);
  }
  return anchor$;
}

/** The island tells where it rests in the view; null once it has no place there. */
export function publishAIIslandAnchor(
  scope: AIIslandAnchorScope,
  next: AIIslandAnchor | null
) {
  const anchor$ = anchorOf(scope);
  const current = anchor$.value;
  if (current?.x === next?.x && current?.y === next?.y) return;
  anchor$.next(next);
}

/** Where the island of the view rests, live. */
export function aiIslandAnchor$(
  scope: AIIslandAnchorScope
): Observable<AIIslandAnchor | null> {
  return anchorOf(scope).asObservable();
}
